import _ from 'lodash';
import { createSelector } from 'reselect';

export const getAllStudents = state => state.students.items;

export const getAllStudentValues = createSelector(
  getAllStudents,
  students => _.chain(students).map(el => ({ id: el.id, name: el.fullName })).value()
);
